<template>
  <div class="content">
    <div class="other_active">
      <div class="other_item">
        <div
          class="item"
          v-for="(item, index) in activeData"
          :key="index"
          @click="activeDetail"
        >
          <div class="vedio">
            <img
              :src="
                collent_toggle
                  ? require('../../static/collent.png')
                  : require('../../static/collent_yello.png')
              "
              @click="toggle"
              class="shoucang"
              alt=""
            />
            <img class="vedio_picture" :src="baseUrl+item.activeImgurl" />
          </div>
          <div class="title">
            <p>{{ item.title }}</p>
            <p style="color: #fdd000; font-size: 16px">
              <span
                ><img src="../../static/ico_time.png" align="absmiddle" alt=""
              /></span>
              {{ item.activeDate }}
            </p>
            <p>
              <span
                ><img src="../../static/ico_address.png" align="absmiddle"
              /></span>
              座位号
              <span style="color: #fdd000">{{ item.BoothNumber }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { forMat } from '../../../utils/common';


export default {
  data() {
    return {
       collent_toggle: false,  //收藏按钮
       baseUrl: forMat(),
      activeData: [
        {
          activeImgurl: require("../../static/tupian.png"),
          title: "靠的住的硬实力山上机械新品发布会",
          activeDate: "2021-11-24 10：00",
          BoothNumber: "",
          company: "中国煤炭工业国际技术支持有限公司",
        },
        {
          activeImgurl: require("../../static/tupian.png"),
          title: "靠的住的硬实力山上机械新品发布会",
          activeDate: "2021-11-24 10：00",
          BoothNumber: "",
          company: "中国煤炭工业国际技术支持有限公司",
        },
        {
          activeImgurl: require("../../static/tupian.png"),
          title: "靠的住的硬实力山上机械新品发布会",
          activeDate: "2021-11-24 10：00",
          BoothNumber: "E1107",
          company: "中国煤炭工业国际技术支持有限公司",
        },
        {
          activeImgurl: require("../../static/tupian.png"),
          title: "靠的住的硬实力山上机械新品发布会",
          activeDate: "2021-11-24 10：00",
          BoothNumber: "E1107",
          company: "中国煤炭工业国际技术支持有限公司",
        },
      ],
      
    };
  },

  components: {},

  computed: {},

  methods: {
       toggle() {
      if (this.collent_toggle == true) {
        this.collent_toggle = false;
      } else if (this.collent_toggle == false) {
        this.collent_toggle = true;
      }
      
    },
    activeDetail(){   //点击活动入口进入
      console.log("活动详情")
    }
  },
};
</script>
<style lang='scss' scoped>
.content {
  width: 1270px;
  margin: 0 auto;
//   border: 1px solid red;
  .other_active {
    // margin-top: 81px;
    h3 {
      font-size: 24px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 29px;
    }
    .other_item {
      display: flex;
    //   margin-top: 30px;
      .item {
        width: 294px;
        height: 354px;
        // margin-top: 20px;
        margin-right: 28px;
        border: 1px solid #e0e0e0;
        .vedio {
          width: 295px;
          height: 197px;
          margin-bottom: 20px;
          border: 1px yellow solid;
          position: relative;
          .shoucang {
            position: absolute;
            top: -1;
            right: 0;
          }
          .vedio_picture {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          box-sizing: border-box;
          height: 117px;
          padding: 0px 35px 50px 24px;
          p {
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>
